/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/
/**
 * @param {Element} el
 * @returns {number}
 */
const outerHeightWithMargin = el => {

    let height = el.offsetHeight;

    const style = getComputedStyle(el);

    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);

    return height;
};

/**
 * Created by vladyslav on 27.11.17.
 */
const windowLoaded = () => {
    return new Promise(resolve => {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            document.addEventListener('readystatechange', () => {
                if (document.readyState === 'complete') {
                    resolve();
                }
            });
        }
    });
};

export { windowLoaded, outerHeightWithMargin };



// WEBPACK FOOTER //
// ./source/helper.js